import { useCallback } from 'react';

// This hook centralizes snackbar/toast behavior for the detail drawer so tabs can
// request notifications and optional follow-up refreshes without duplicating policy.
const useDetailPanelNotify = ({
  handleSnackbarNavigate,
  programKey,
  currentBac,
  requestSingleDealerRefresh,
  setSnackbar,
}) =>
  useCallback(
    (message, severity = 'success', options = {}) => {
      console.info('[DetailPanel] toast', { message, severity, options });
      if (!options.suppressSnackbar) {
        const onClick = options.navigateToHistory ? handleSnackbarNavigate : options.onClick || null;
        setSnackbar({ open: true, message, severity, onClick, key: Date.now() });
      }

      if (options.refreshDealer) {
        // Some mutations queue a follow-up single-dealer refresh so the drawer can
        // reconcile server-side changes back into the currently open row.
        const programNameForRefresh = options.refreshProgramName || programKey || null;
        const bacForRefresh = options.refreshBac || currentBac || null;
        const delayMs = Number(options.refreshDelayMs || 0) + 1000;
        if (programNameForRefresh && bacForRefresh) {
          requestSingleDealerRefresh({ programName: programNameForRefresh, bac: bacForRefresh, delayMs, force: false });
        }
      }
    },
    [currentBac, handleSnackbarNavigate, programKey, requestSingleDealerRefresh, setSnackbar]
  );

export default useDetailPanelNotify;
